// extracted by mini-css-extract-plugin
module.exports = {"root":"ViewContainerTable_root__1Ruu9"};